/**
 * fl-free-shipping.js
 * Actualiza la barra de envío gratis cuando cambia el carrito.
 * cart.total_price (Shopify) viene en cents ×100 — CLP zero-decimal. $100.000 = 10.000.000 cents.
 * Robusto: sync al cargar + intercepta fetch a /cart/* + eventos + MutationObserver.
 */
(function () {
  'use strict';

  function formatCLP(cents) {
    var clp = Math.round(cents / 100);
    return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(clp);
  }

  function updateBar(totalCents) {
    var bars = document.querySelectorAll('.fl-fsbar');
    bars.forEach(function (bar) {
      var threshold = parseInt(bar.dataset.threshold, 10);
      var fill = bar.querySelector('.fl-fsbar__fill');
      var msg = bar.querySelector('.fl-fsbar__msg');
      if (!threshold || !fill || !msg) return;
      var pct = Math.min(100, (totalCents / threshold) * 100);
      fill.style.width = pct + '%';
      bar.setAttribute('aria-valuenow', totalCents);
      bar.dataset.total = totalCents;
      if (totalCents >= threshold) {
        msg.innerHTML = '¡Tienes envío gratis! 🎉';
        bar.classList.add('fl-fsbar--free');
      } else {
        var remaining = threshold - totalCents;
        msg.innerHTML = 'Te faltan <strong>' + formatCLP(remaining) + '</strong> para envío gratis ' +
          '<span class="fl-fsbar__sub">· Envío gratis sobre ' + formatCLP(threshold) + '</span>';
        bar.classList.remove('fl-fsbar--free');
      }
    });
  }

  var pending = false;
  function fetchAndUpdate() {
    if (pending) return;
    pending = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { pending = false; updateBar(cart.total_price); })
      .catch(function () { pending = false; });
  }

  // 1) Sync inicial (refleja el carrito real aunque la barra se haya renderizado con otro estado)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchAndUpdate);
  } else {
    fetchAndUpdate();
  }

  // 2) Interceptar fetch a endpoints de carrito (lo más fiable, independiente del tema)
  if (window.fetch && !window.__flFsbPatched) {
    window.__flFsbPatched = true;
    var origFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var path = (typeof url === 'string') ? url : (url && url.url) || '';
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js)?/.test(path)) {
        p.then(function () { setTimeout(fetchAndUpdate, 60); }).catch(function () {});
      }
      return p;
    };
  }

  // 3) Eventos conocidos (Horizon y otros) + 4) MutationObserver de respaldo
  ['cart:updated', 'cart:change', 'cart:refresh', 'CartUpdateEvent', 'CartAddEvent', 'cart:rerender'].forEach(function (ev) {
    document.addEventListener(ev, fetchAndUpdate);
  });
  var watch = function () {
    var items = document.querySelector('.cart-drawer__items, cart-items, .cart-items, [class*="cart-drawer"]');
    if (!items) return;
    new MutationObserver(function () { setTimeout(fetchAndUpdate, 100); })
      .observe(items, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', watch); } else { watch(); }
})();
